import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { DIVIDER_COLOR } from '../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4, 0),
    color: DIVIDER_COLOR,
    textAlign: 'center',
    fontWeight: 'bold',
    fontFamily: 'Montserrat, sans-serif',
    letterSpacing: 1.36,

    fontSize: theme.typography.pxToRem(20),
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(34),
    },
  },
}));

const ComingSoonContent = () => {
  const classes = useStyles();
  return <div className={classes.root}>COMING SOON...</div>;
};

export default ComingSoonContent;
